<script lang="ts">
    import { createEventDispatcher } from "svelte"
    import { mdiPencil, mdiTrashCan } from "@mdi/js"
    import Icon from "../../../widgets/Icon.svelte"
    import { tooltip } from "../../../../helper"
    import { _ } from "svelte-i18n"
    export let title: string = ""

    let dispatch = createEventDispatcher()
    let value = title
    let input: HTMLInputElement
</script>

<style lang="less">
    .filter-title-field {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        gap: 10px;
        border: 0;
        border-bottom: 1px solid transparent;
        transition: all 0.4s ease-in-out;

        input {
            background-color: transparent;
            border-radius: 0;
            border: 0;
            margin: 0;
            padding: 0;
            font-size: 24px;
            letter-spacing: normal;
            width: 90%;
            max-width: 100%;
            height: 36px;
        }

        .actions {
            display: flex;
            justify-content: flex-start;
            align-items: center;
            gap: 10px;
            opacity: 0.4;
            transition: all 0.4s ease-in-out;

            .btn {
                color: #ccc;
                height: 24px;
                &:hover {
                    color: var(--textcolor);
                }

                &.delete-cart:hover {
                    color: var(--renzrot);
                }
            }
        }

        &:hover {
            border-bottom: 1px dashed #ccc;
        }
    }
</style>

<!-- svelte-ignore a11y-no-static-element-interactions -->
<div class="filter-title-field" on:click|stopPropagation on:keydown>
    <input
        size="{value.length}"
        placeholder="{$_('components.pcalc.groupNamePlaceholder')}"
        data-cy="group-name"
        bind:this="{input}"
        bind:value
        on:change="{() => dispatch('change', value)}"
    />

    <div class="actions">
        <button
            class="btn btn-link"
            data-cy="edit-group-name"
            on:click|preventDefault|stopPropagation="{() => input.focus()}"
            use:tooltip="{{ content: $_('components.pcalc.editGroupName') }}"
        >
            <Icon path="{mdiPencil}" size="24px" />
        </button>
        <!-- svelte-ignore missing-declaration -->
        <button
            class="btn btn-link delete-cart"
            on:click|preventDefault|stopPropagation="{() => {
                dispatch('remove')
            }}"
            use:tooltip="{{ content: $_('components.pcalc.deleteGroup') }}"
            data-cy="delete-group"
        >
            <Icon path="{mdiTrashCan}" size="24px" />
        </button>
    </div>
</div>
